import fetch from 'isomorphic-unfetch';

import { manageDateObject, isValidDateObject } from '../../../../util/date';
import { parents } from '../../../../util/dom';
import {
  isPassword,
  isPhoneNumber,
  isMemberNumber,
  isBankAccountNumber,
  isBankSortCode,
} from '../../../../util/regex';
import {
  API_DOES_MEMBERSHIP_NUMBER_EXIST,
  API_DOES_MEMBERSHIP_EMAIL_EXIST,
  MEMBERSHIP_STATUS_DD_PENDING,
  MEMBERSHIP_STATUS_PAID,
  SECTION_EXPANDED_CLASS,
  OVERSEAS_CLASS,
} from '../constants';
import {
  MAX_LENGTH_FEET,
  MAX_LENGTH_METERS,
  MAX_WIDTH_METERS,
  MAX_WIDTH_FEET,
} from '../../../../constants/camping-units';
import {
  MIN_ADULT_AGE,
  MAX_CHILD_AGE,
  MAX_AGE,
} from '../../../../constants/member-ages';

function emailRegExMatch(emailString) {
  const emailRegExp = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g);
  let emailMatch;

  if (emailString.match(emailRegExp)) {
    emailMatch = true;
  } else {
    emailMatch = false;
  }

  return emailMatch;
}

function dateRegExMatch(date) {
  const dateRegExp = new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[/](0?[1-9]|1[012])[/-]\d{4}$/g);
  let dateMatch;

  if (date.match(dateRegExp)) {
    dateMatch = true;
  } else {
    dateMatch = false;
  }
  return dateMatch;
}

function isAdult(ageDateObject) {
  const minimumDateObject = new Date();
  const maximumDateObject = new Date();
  minimumDateObject.setFullYear(minimumDateObject.getFullYear() - MIN_ADULT_AGE);
  maximumDateObject.setFullYear(maximumDateObject.getFullYear() - MAX_AGE);
  const isValid = ageDateObject.getTime() < minimumDateObject.getTime() && ageDateObject.getTime() >= maximumDateObject.getTime();

  return isValid;
}

function isChild(ageDateObject) {
  const maximumDateObject = new Date();
  maximumDateObject.setFullYear(maximumDateObject.getFullYear() - MAX_CHILD_AGE);
  const isValid = ageDateObject.getTime() >= maximumDateObject.getTime();

  return isValid;
}


export function ifHiddenAbort(input) {
  let isHidden = false;
  const inputParents = parents(input, '[data-jra-form-expandable-section]');
  const expandableSection = inputParents[0];

  if (expandableSection) {
    // this causes a feedback loop due to the MutationObserver.
    if (expandableSection.dataset.form && expandableSection.dataset.form === 'control') {
      throw new Error("the data attribute data-jra-form-expandable-section can't be added to an element with data-form='control', control of input.id: ", input.id);
    }

    const isClosed = !expandableSection.classList.contains(SECTION_EXPANDED_CLASS);

    if (isClosed) {
      isHidden = true;
    }
  }

  return isHidden;
}

export function isDate(input) {
  const dateString = input.value;
  let isValid = true;

  if (dateString !== '' && dateRegExMatch(dateString)) {
    const dateObject = manageDateObject(dateString);
    if (isValidDateObject(dateObject)) {
      isValid = true;
    } else {
      isValid = false;
    }
  } else {
    isValid = false;
  }
  return isValid;
}


export function ifUnsetAbort(input) {
  return input.value === '';
}

export function hasSelectedCountry(input) {
  const formNode = parents(input, 'form');
  const isVisible = formNode[0].classList.contains(OVERSEAS_CLASS);
  const isUK = input.dataset.jraFormCountryName === 'United Kingdom';
  const isRenewForm = document.querySelector('.JraRenewBar');
  const hasSelectedCountryFromList = input.dataset.jraFormCountryName !== '' && input.value === input.dataset.jraFormCountryName;
  if ((hasSelectedCountryFromList && isVisible) || (isUK && !isVisible) || (isRenewForm && hasSelectedCountryFromList)) {
    return true;
  }

  return false;
}

export function hasSelectedOverseasCountry(input) {
  const formNode = parents(input, 'form');
  const isVisible = formNode[0].classList.contains(OVERSEAS_CLASS);
  const isUK = input.dataset.jraFormCountryName === 'United Kingdom';

  if ((!isUK && isVisible) || (isUK && !isVisible)) {
    return true;
  }

  return false;
}

export function required(input) {
  if (input.type === 'checkbox') {
    if (input.checked) {
      return true;
    }
  } else if (input.value !== '') {
    return true;
  }

  return false;
}

export function dobRequired(input) {
  if (input.value !== '00/00/0000') {
    return true;
  }

  return false;
}

export function adultDob(input) {
  const dateString = input.value;
  let isValid = true;

  if (dateString !== '' && dateRegExMatch(dateString)) {
    const dateObject = manageDateObject(dateString);

    if (isValidDateObject(dateObject) && isAdult(dateObject)) {
      isValid = true;
    } else {
      isValid = false;
    }
  } else if (dateString !== '' && !dateRegExMatch(dateString)) {
    isValid = false;
  }

  return isValid;
}


export function childDob(input) {
  const dateString = input.value;
  let isValid = true;

  if (dateString !== '' && dateRegExMatch(dateString)) {
    const dateObject = manageDateObject(dateString);

    if (isValidDateObject(dateObject) && isChild(dateObject)) {
      isValid = true;
    } else {
      isValid = false;
    }
  } else if (dateString !== '' && !dateRegExMatch(dateString)) {
    isValid = false;
  }

  return isValid;
}


export function email(input) {
  const emailString = input.value;
  let isValid = true;

  if (emailString !== '' && !emailRegExMatch(emailString)) {
    isValid = false;
  }

  return isValid;
}


export function isUniqueWithinForm(input) {
  let isValid = true;
  const parentsNodes = parents(input, 'form');
  if (parentsNodes && parentsNodes.length) {
    const form = parentsNodes.pop();
    isValid = [...form.querySelectorAll('input[type=email]')]
      .every(emailInput => (
        emailInput === input
        || emailInput.value !== input.value
      ));
  }

  return isValid;
}


export function isNotMemberEmailAsync(input, callBack) {
  // we check to see if we actually need to bother to perform async check
  // if email has not changed from original value.
  if (
    (
      input.dataset.formValidationEmailValue !== undefined
      && input.dataset.formValidationEmailValue.length > 0
    )
    && input.dataset.formValidationEmailValue === input.value
  ) {
    callBack(true);
    return;
  }

  fetch(`${API_DOES_MEMBERSHIP_EMAIL_EXIST.replace('#{1}', input.value)}`)
    .then(response => response.json())
    .then((json) => {
      callBack(json.MembershipFound === false);
      if (__DEVELOPMENT__) {
        console.log('isNotMemberEmailAsync parsed json', json);
      }
    }).catch((error) => {
      if (__DEVELOPMENT__) {
        console.log('isNotMemberEmailAsync parsing failed', error);
      }
    });
}


export function passwordFormat(input) {
  return isPassword(input.value);
}


export function phoneNumber(input) {
  return isPhoneNumber(input.value);
}


export function memberFormat(input) {
  return isMemberNumber(input.value);
}


export function campingUnitBothPresent(input) {
  let isValid = true;
  const parentsNodes = parents(input, '[data-form="control"]');
  if (parentsNodes && parentsNodes.length) {
    const formControl = parentsNodes.pop();

    const lengthInput = formControl.querySelector('[data-form-validation-length-input]');
    const widthInput = formControl.querySelector('[data-form-validation-width-input]');
    const length = parseFloat(lengthInput.value, 10);
    const width = parseFloat(widthInput.value, 10);

    // ensure that the control is not optionally empty
    if (lengthInput.value === '' && widthInput.value === '') {
      return true;
    }

    if (
      (length === 0 || width === 0)
      && lengthInput.value !== widthInput.value
    ) {
      isValid = false;
    } else if (Number.isNaN(length) || Number.isNaN(width)) {
      isValid = false;
    }
  }

  return isValid;
}


export function campingUnitWithinRange(input) {
  let isValid = true;
  /**
   * Length - validation limit up to 10.5m/34ft
   * Width - validation limit up to 7.25m/24ft
   */
  const parentsNodes = parents(input, '[data-form="control"]');
  if (parentsNodes && parentsNodes.length) {
    const formControl = parentsNodes.pop();

    const lengthInput = formControl.querySelector('[data-form-validation-length-input]');
    const widthInput = formControl.querySelector('[data-form-validation-width-input]');
    const unitSelect = formControl.querySelector('[data-form-validation-unit-select]');

    const unit = (unitSelect) ? unitSelect.value : 'm';
    const length = parseFloat(lengthInput.value, 10);
    const width = parseFloat(widthInput.value, 10);

    if (unit === 'ft' && length > MAX_LENGTH_FEET) {
      isValid = false;
    } else if (unit === 'm' && length > MAX_LENGTH_METERS) {
      isValid = false;
    } else if (unit === 'ft' && width > MAX_WIDTH_FEET) {
      isValid = false;
    } else if (unit === 'm' && width > MAX_WIDTH_METERS) {
      isValid = false;
    }
  }

  return isValid;
}


export function isMemberAsync(input, callBack) {
  fetch(`${API_DOES_MEMBERSHIP_NUMBER_EXIST.replace('#{1}', input.value)}`)
    .then(response => response.json())
    .then((json) => {
      const membershipFound = json.MembershipFound &&
        (json.MembershipStatus === MEMBERSHIP_STATUS_PAID
        || json.MembershipStatus === MEMBERSHIP_STATUS_DD_PENDING);
      callBack(membershipFound);
      if (__DEVELOPMENT__) {
        console.log('isMemberAsync parsed json', json);
      }
    }).catch((error) => {
      if (__DEVELOPMENT__) {
        console.log('isMemberAsync parsing failed', error);
      }
    });
}


export function bankAccountNumberFormat(input) {
  return isBankAccountNumber(input.value);
}


export function bankSortCodeFormat(input) {
  return isBankSortCode(input.value);
}
